import React from 'react';
import { cn } from '../../lib/utils';
import { SidebarHeader } from './SidebarHeader';
import { Navigation } from './Navigation';
import { History } from './History';
import { NewChatButton } from './NewChatButton';
import { useSidebar } from 'contexts/SidebarContext';

export const Sidebar: React.FC = () => {
  const { isCollapsed, toggleCollapse, isMobile, isMobileOpen, setMobileOpen } = useSidebar();

  return (
    <>
      {/* Mobile backdrop */}
      {isMobile && isMobileOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <div
        className={cn(
          'transition-all duration-200 ease-in-out border-r border-border',
          isMobile ? 'bg-white' : 'bg-[rgba(217,217,217,0.20)]', // Solid bg on mobile overlay
          isMobile
            ? 'fixed inset-y-0 left-0 z-50 w-[280px] transform transition-transform duration-200'
            : isCollapsed ? 'w-20' : 'w-[280px]', // Desktop: Fixed widths to prevent layout shift
          isMobile && !isMobileOpen && '-translate-x-full',
          isMobile && isMobileOpen && 'translate-x-0',
        )}
      >
        <div className="flex flex-col h-full">
          {/* Header with Logo and Collapse Button */}
          <SidebarHeader isCollapsed={!isMobile && isCollapsed} onToggleCollapse={toggleCollapse} />

          {(isMobile || !isCollapsed) && (
            <>
              {/* Chat Assistant Header */}
              <div className="px-6 pt-4 pb-0">
                <h2 className="text-black font-bold font-ld">Chat Assistant</h2>

                {/* New Chat Button */}
                <NewChatButton isCollapsed={false} />
              </div>

              {/* Navigation */}
              <Navigation isCollapsed={false} />

              {/* History Section */}
              <History isCollapsed={false} />
            </>
          )}
        </div>
      </div>
    </>
  );
};
